import React, { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import image1 from '../image/articles/article5.webp';
import image2 from '../image/articles/article51.webp';
import image3 from '../image/articles/article52.webp';
import image4 from '../image/articles/article53.webp';
import image5 from '../image/articles/article54.webp';
import image6 from '../image/articles/article55.webp';
import image7 from '../image/articles/article56.webp';
import image8 from '../image/articles/article57.webp';
import article1Thumbnail from '../image/articles/article4-1.webp';
import ProtectedPage from "../components/ProtectedPage";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Divider } from "@mui/material";
import { Wavedivider } from "../components/Wavedivider";
import { QuoteBlock } from "../components/QuoteBlock";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';

function Article5(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      const images2 = [image2, image3]; 
      const images3 = [image4];
      const images4 = [image5, image6];
      const images5 = [image7, image8];
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ARTICLE5_PASSWORDS
      );
      
      useMetaTags({
        title: '25.11. 회고 - Lynkim',
        description: '사계절 만끽하기 / PM을 맡아 외부협력사와 함께 잘 일하기 / 거절을 못하는건 사실 이기적인 마음이다',
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
          <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
          <div className='fadeIn '>
            <ArticleTitle
              title={'25.11. 회고'} 
              description={<div>사계절 만끽하기 / PM을 맡아 외부협력사와 함께 잘 일하기 / 거절을 못하는건 사실 이기적인 마음이다</div>} 
              category={'essay'} 
              date={'2025.12.01.'}
              thumbnail={image1}/>
          </div>
          <Wavedivider/>
          <div className='articleLayout'>
            <ArticleTextSection
                title = '프롤로그'
                subTitle = {<div>사계절 만끽하기</div>}
                description= {<div>
                    사계절 중에 여름을 제일 좋아하고, 가을이 오면 추워지는 느낌이 싫어서 우울한 감정을 느끼지만, 단풍이 드는 것을 보면 항상 아름다움과 뭉클한 감동을 느낀다. 왠지 한 여름을 견뎌내고 나서 마음놓고 자유롭게 삶의 무게를 내려놓은 여유로움을 보는 것만 같다. 

                    <br/>

                    올해 처음으로 가을 정동길을 걸었는데, 이렇게 아름다운 풍경을 보게될 줄 몰랐다. 살아오면서 본 가을 중에 가장 아름다움을 느꼈던 것 같다.  

                    <br/><br/>

                    정동길 단풍나무 아래에서 마술을 보여주고 있던 18살 청년분이 인상깊게 남았는데, 스스로 완벽하지 않음에도 자신의 꿈을 많은 사람들 앞에서 자신감있게 말하고, 응원해달라고 하는 모습이 너무 멋있고 뭉클하기 까지 했다. <br/>

                    다른 사람의 시선을 상관하지 않은채 열정을 가지고 자신의 꿈을 향해 도전하는 사람들을 보면, 왠지 마음이 뭉클해진다. 나는 지금조차 나의 조금이라도 부족한 모습을 숨기려고 하고, 자신감을 갖지 못한채 다른 사람들 앞에 서는 것을 부끄러워 하는데, 그런 사람들을 보면 참 본받을게 많다고 느낀다. <br/>

                    꼭 나중에 이름있는 마술사로 다시 보게되면 좋겠다.</div>}
            />
            
            <ArticleImageLayout images={images2} />

            <ArticleTextSection 
                marginTop={true}
                title = 'PM을 맡아 외부협력사와 함께 잘 일하기'
                description=
                  {<div>
                    최근 팀을 이동하고 나서, 업무 환경과 역할이 완전히 달라졌다. 그동안은 디자이너로서의 역할에 집중하면 되었지만, 이제는 PM으로서의 책임까지 함께 가져가야 했다. 도메인도 광고에서 QR오더로 완전히 바뀌다보니 새로운 역할에 적응하기까지 시간이 오래 걸렸다. 그 과정에서 느껴지는 심리적인 압박도 너무 컸다.
                    <br/><br/>
                    광고를 맡았을 때는 광고 소비 유저와 광고 생산 유저, 양 사이드를 고민하더라도 온라인 환경에서의 사용성에만 초점을 맞춰도 되었는데, 지금 맡고 있는 QR오더 서비스는 구매자와 가치를 경험하는 대상이 다르고, 사용환경도 오프라인이기 때문에 완전히 다른 UX 설계가 필요했다. <br/>
                    또 제품을 사용하는 유저뿐 아니라, 서비스를 선택해 계약하는 ‘업체’를 설득해야 했기 때문에, 단순히 UX를 잘 만드는 능력만으로는 부족했고, 경쟁 환경 속에서 우리 서비스가 어떻게 차별화될 수 있을지를 전략적으로 바라봐야 했다.
                    <br/><br/>
                    기존의 온라인 서비스는 유저가 설계한 방식대로 서비스를 이용하고, 서비스의 가치를 온전히 느끼도록 하는 것이 중요했다면, 지금의 QR오더 서비스는 어떻게 하면 우리 서비스가 경쟁환경 속에서 차별화를 갖추고, 제품을 사용하는 유저가 아닌 제품을 채택하여 구매하는 유저가 만족할 수 있도록 전략을 수립하는 것이 훨씬 중요했다. 
                    <br/><br/>
                    이 과정에서 처음 세운 전략은 계속해서 수정되었고, 계약이나 외부 상황이 급변함에 따라 계속해서 다시 또 새롭게 대응해야 했다. 그 과정에서 가장 어려웠던 점은,  변화하는 생각을 팀원들과 투명하게 공유하고, 끊임없이 동기화하는 것이었다. PM은 상황에 맞게 우선순위를 정교하게 정리하고, 전략이 수정될 때마다 다시 팀과 생각을 맞추고 설득해야 했다. <br/>
                    처음 세운 전략은 지속적으로 바뀌어갔고, 생각이 정해졌다가도 빠르게 바뀌기 때문에, 어떻게 하면 팀원들과 생각을 더 잘 나누고, 계속 생각을 동기화할 수 있을지가 가장 어려운 과제였다. 
                    </div>} 
                 marginBottom={true}
            />
            <ArticleImageLayout images={images4} />            
            <ArticleImageLayout images={images5} />
            <ArticleTextSection 
              marginTop={true}
              description=
                {<div>
                  또한 가장 큰 문제는 회사 내부에서 동일한 문화, 동일한 업무방식을 가져온 사람들과만 함께 일을 하는 것이 아닌, 잘 알지못하는 다른 회사와 긴밀하게 협업하게 된 것이었다.  
                    직책과 직급, 협업 방식 등 업무 방식이 너무나 다른 업체와 일하면서, 잘 소통하고 일하는 환경을 갖추기까지 오랜 시간이 걸렸고, 일이 진척되지 않는 것, 업무 현황이 불투명한 것 등 많은 문제와 어려움이 발생했는데, 어떤 원인으로 인해 발생하는 지를 알아채는 것부터도 쉽지 않았다. 
                    <br/>
                    그렇게 6개월 정도 일을 하면서, 이제서야 문제와 원인이 가시적으로 보이기 시작했고, 돌아보며 앞으로 협력사와 더 잘 일하기 위해서는 어떻게 해야하는가에 대해 느낀점이 몇 가지 있다.
                    <br/><br/>
                    <b>1. 다른 회사라고 할지라도 같은 회사 팀원처럼 모든 것을 투명하게 싱크맞춰야 하더라 <br/></b>
                 </div>}
            />
            <QuoteBlock>
                목표나 전략을 세우고, PRD를 쓸 때조차 내부에서만 공유하는 것이 아니라, 협력업체에게 투명하게 공유하고, 기획 리뷰에 타 회사의 담당자를 참여시켜야 한다. 
                작업자가 내부인원이라 내부에서만 공유되어도 된다고 생각한 것은 섯부른 판단이었다. 되도록 더 많은 맥락을 자주 공유를 해야 한다. 분명 나중에 되서야 문제가 발견되고, 생각보다 큰 문제가 될 수도 있다.  <br/>
                협력업체에게도 완성된 결과물이 나오기 이전에 기획과 생각을 더 공유하도록 요구해야 한다. 다 완료되고 나서 공유를 받으면, 꼭 잘못 이해한 것이 있다. 
            </QuoteBlock>

            <ArticleTextSection 
              marginTop={true}
              description=
                {<div>
                    <b>2. 일하는 프로세스는 최대한 통일해야 한다.</b>
                </div>}
            />
            <QuoteBlock>
            가장 큰 문제는 내부에서 어려움을 겪으면, 협력하는 업체에 공유하지 않고 문제를 숨기기 시작하는 것이다.  <br/>  
            태스크 관리를 위한 툴을 하나로 통일해서 진행상황을 투명하게 보이게 해야 한다. 일의 진행이 안되고 있다면, 자발적으로 표현하지 않아도 문제를 겪고 있다는 것을 확인할 수 있게 된다.
            </QuoteBlock>
            <ArticleTextSection 
              marginTop={true}
              description=
                {<div>
                    <b>3. 조금이라도 관련되어 있다면, 프로젝트의 진행상황을 모두 파악해야 한다.</b>
                </div>}
            />
            <QuoteBlock>
              진행하고 있는 프로덕트에 리소스가 투입이 안된다고 해서 진행상황을 몰라도 되는 것은 없다. 조금이라도 관련된 업무라면 진행상황을 적극적으로 확인하고, 그들의 프로덕트의 구조를 더 자세히 알아서, 우리 제품의 인사이트를 얻고, 미리 블로커가 생길 수 있는 부분을 제거할 수 있다. 
            </QuoteBlock>
            <ArticleTextSection 
              marginTop={true}
              description=
                {<div>
                    <b>4. 동등한 위치에서 소통해야 한다.</b>
                </div>}
            />
            <QuoteBlock>
            협력 업체에서 본인들이 외주업체처럼 주는 일만 받아서 하게 되었다는 불만의 소리를 내비쳤다고 한다. 이런 상황인지 뒤늦게 알게되었는데, 이렇게 사기가 떨어지게 되면, 자연스럽게 업무의 진척이 늦어지고, 실수나 많아지고, 공유가 투명하지 않게 된다. 심리적으로 불만을 갖게 되면 업무의 효율에도 큰 영향을 끼치게 된다.<br/> 협력업체의 분위기도 지속적으로 살피고, 동등하게 협력한다는 느낌을 계속 주어야 한다.
           </QuoteBlock>
            <ArticleTextSection 
                title = '거절을 못하는건 사실 이기적인 마음이다'
                description=
                  {<div>
                    지인이 자신의 논문에 필요한 일러스트를 그려달라고 도움을 구해왔다. 그 순간 거절을 못해서 “좋아요”라고 대뜸 말해버렸는데, 그게 또 연쇄적으로 한번 도와주겠다고 했으니 말을 바꿀 수가 없어서 끝내 책임지고 도움을 주기로 했다. <br/>

                    그렇게 일러스트 그림을 그려주기 시작했는데, 생각한 것보다 간단하게 끝날만큼 쉬운 것도 아니였고, 내 시간과 노력을 꽤나 들여야 했다. 그러다보니 중간중간 도움을 주는게 귀찮고, 그만하고 싶다는 생각이 들기도 했다. 하지만 또 잘 해보고 싶은 마음도 들어서 결국 또 열심히 몰입했고, 제출까지 잘 마치고 그들에게서 감사하다는 말을 들으니까 그것만으로 기분이 좋긴 했다.
                    <br/><br/>
                    중간중간 내가 왜 이렇게 까지 아무런 대가 없이 도움을 주어야 하는가 곰곰히 생각하게 되었는데, 나중에 도움받은 사람이 나에게 도움을 줄 수 있지않을까, 가까워지면 또 인맥에 도움이 되지 않을까 하는 생각을 하는 것이 있었던 것 같다.<br/>
                    이 일로 인해서 내가 사람을 계산적으로 생각하고 내 필요에 의해 도움을 주는 간사한 사람이구나 라는 것을 느끼고 부끄러움이 느껴졌다. 도움을 줄 때 그냥 도와주고 싶은 순수한 마음이 아니라, 그저 거절을 못하고, 그 사람이 나중에 도움을 줄지도 몰라서 내 인생에 도움이 되지 않을까? 이런 계산적인 생각을 하며 도움을 주고 있었다.
                    <br/><br/>
                    친구에게 이런 속내를 털어놓았더니, 내가 그저 순수히 도움을 주고 싶어하는 마음을 가진 사람이 아니라, 계산적인 사람이라는 것에 놀라고 혼란을 느끼고, 나에게 실망스러운 마음까지 들었다고 했다. 우연찮은 일화로 나 스스로도 뜻하지 않게 내가 가진 어두운 마음을 마주하고 스스로에게 실망하게 된 계기가 되어버렸다. 스스로에게 실망하고 부끄러운 만큼 그 태도와 마음은 고쳐야겠다는 생각이 든다. 
                  </div>} 
                marginTop={true}
                marginBottom={true}
            />
            <QuoteBlock>
              그냥 순수한 마음으로 내가 다른 사람에게 도움이되었다는 것만으로 기쁨을 느끼던지, <br/>
              누군가 거절을 회피함으로 인해 불편할 걸 제대로 알고 제대로 싫다고 거절하던지.
            </QuoteBlock>
            <ArticleImageLayout images={images3} />
            
            
          </div>    
          
          <NextItem to='/Article4' thumbnail={article1Thumbnail} nextProjectTitle='25.10. 회고'/>

          <BackButton/>
          </ProtectedPage>
        </>
      )
  }
  
  export default Article5;
